<template>
	<VDialogV3
		ref="dialog"
		id="vehicle-type-card"
		position="right"
		width="600px"
		height="100vh"
    :entity="localVehicleType"
		:loading="localVehicleType == null"
		:submit-disabled="isSaveDisabled"
		:submit-method="submit"
	>
		<section>
      <VInput
        ref="nameInput"
        v-model="localVehicleType.name"
        label="Название"
        layout="vertical"
        required
        :max-length="200"
      />
		</section>

		<template #footer>
			<VButton
				theme="primary"
				@click="$refs.dialog.submit()"
			>
				Сохранить
			</VButton>

			<VButton
				v-show="localVehicleType?.isExisting === true"
				@click="onDelete"
			>
				Удалить
			</VButton>
		</template>
	</VDialogV3>
</template>

<script lang="ts">

import VehicleType         from '@/domains/VehicleTypes/VehicleType';
import VehicleTypesService from '@/domains/VehicleTypes/VehicleTypesService';

export default defineComponent({
	name: 'VehicleTypeCard',

	props: {
		/** Готовый объект — передаётся из реестра */
		vehicleType: {
			type:    VehicleType,
			default: null,
		},
		/** ID — карточка сама загружает объект */
		id: {
			type:    Number,
			default: null,
		},
	},

	data() {
		return {
			localVehicleType: null as VehicleType | null,
		};
	},

	computed: {
		isSaveDisabled(): boolean {
			return !this.localVehicleType?.name;
		},
	},

	async mounted() {
		await this.init();
	},

	methods: {
		async init(): Promise<void> {
			const id = this.id ?? this.vehicleType?.id;
      if (id) {
				this.localVehicleType = await VehicleTypesService.get(id);
			}
			else {
				this.localVehicleType = new VehicleType();
			}
		},

		async submit(): Promise<boolean> {
			if (this.localVehicleType.isExisting === true) {
				return await VehicleTypesService.update(this.localVehicleType);
			}
			else {
				return await VehicleTypesService.add(this.localVehicleType);
			}
		},

		async onDelete(): Promise<void> {
			const success = await VehicleTypesService.deleteWithConfirmation(this.localVehicleType);

			if (success === true) {
				this.$core.dialogs.VehicleTypeCard.resolve();
			}
		},
	},
});
</script>